import { Stack, type Breakpoint } from "@mui/material";
import type { ComponentProps } from "react";
import type { DocumentType } from "generated-graphql/graphql";
import { Dialog } from "components/Dialog";
import { DocumentFilePicker, type DocumentFilePickerProps } from "../../shared";
import { FacilityDocumentPicker } from "components/FacilityDocumentPicker";
import type { FacilityDocumentPickerItem } from "components/FacilityDocumentPicker";
import { FacilityDocumentTypePicker } from "components/FacilityDocumentTypePicker";

type DialogCommonProps = ComponentProps<typeof Dialog>;

type UploadStepProps = {
  dialogProps: DialogCommonProps;
  dialogWidth: Breakpoint;
  showFacilityDocumentPicker: boolean;
  facilityId?: string;
  documentPickerOptions: { label: string; value: DocumentType }[];
  selectedDocumentType?: DocumentType;
  onDocumentTypeChange: (documentType: DocumentType) => void;
  onDocumentPick: (document: FacilityDocumentPickerItem) => void;
  documentFilePickerProps: DocumentFilePickerProps;
  acceptableFileFormats: string[];
  hasInvalidFileExtension: boolean;
  isUploading: boolean;
  isSaving: boolean;
};

export function UploadStep({
  dialogProps,
  dialogWidth,
  showFacilityDocumentPicker,
  facilityId,
  documentPickerOptions,
  selectedDocumentType,
  onDocumentTypeChange,
  onDocumentPick,
  documentFilePickerProps,
  acceptableFileFormats,
  hasInvalidFileExtension,
  isUploading,
  isSaving,
}: UploadStepProps) {
  return (
    <Dialog {...dialogProps} maxWidth={dialogWidth}>
      <Stack spacing={2}>
        {showFacilityDocumentPicker && (
          <>
            <FacilityDocumentTypePicker
              documentTypes={documentPickerOptions.map(
                (option) => option.value
              )}
              onSelectDocumentType={onDocumentTypeChange}
              selectedDocumentType={selectedDocumentType}
            />
            <FacilityDocumentPicker
              facilityId={facilityId ?? ""}
              documentTypes={documentPickerOptions.map(
                (option) => option.value
              )}
              onSelect={onDocumentPick}
              disabled={isUploading || isSaving}
              selectedDocumentType={selectedDocumentType}
              acceptableFileFormats={acceptableFileFormats}
              hasInvalidFileExtension={hasInvalidFileExtension}
            />
          </>
        )}
        <DocumentFilePicker
          {...documentFilePickerProps}
          disabled={isUploading || isSaving || documentFilePickerProps.disabled}
        />
      </Stack>
    </Dialog>
  );
}
